import { render } from "./StartSurvey.vue?vue&type=template&id=4b5fcfd8&scoped=true"
import script from "./StartSurvey.vue?vue&type=script&lang=js"
export * from "./StartSurvey.vue?vue&type=script&lang=js"

import "./StartSurvey.vue?vue&type=style&index=0&id=4b5fcfd8&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5fcfd8"]])

export default __exports__